import React, {useEffect} from 'react';
import {FormElements} from "../../../../shared/ui/form/FormElements";
import {StructureFormModel} from "../../../../shared/ui/form/models/FormModule";
import {formControlTypes} from "../../../../shared/ui/form/models/formControlTypes";
import {useForm} from "../../../../shared/utils/forms/useForm";
import {UseFormSubmitModel} from "../../../../shared/utils/forms/models/UseFormModel";
import {required} from "../../../../shared/utils/forms/utils/validationType";
import Label from "../../../../shared/ui/form/label/Label";
import {padNum} from "../../../../shared/utils/generalUtils";
import {FormElementsArray} from "../../../../shared/ui/form/FormElementsArray";
import BtnRow from "../../../../shared/ui/form/BtnRow";
import http from "../../../../shared/utils/http";
import {useSelector} from "react-redux";
import {addPharmacy, editPharmacy, selectSelectedPharmacist} from "../../../../core/reducer/auth/authSlice";
import {useAppDispatch} from "../../../../app/hooks";

const FormAddCompany = ({closeFormHandler, dataEdit}: { closeFormHandler: () => void, dataEdit: any }) => {
    const pharmacist = useSelector(selectSelectedPharmacist)
    const dispatch = useAppDispatch()


    useEffect(() => {
        if (dataEdit && dataEdit?.idDocument) {
            setData({
                ...dataEdit,
            })
        }
    }, [dataEdit]);
    const submitActionHandler: UseFormSubmitModel = (data) => {
        const dataToSend = {
            ...dataFormatted,
            ...(dataFormatted?.shiftDuration ? {
                shiftDuration: {
                    hours: +dataFormatted?.shiftDuration?.hours,
                    minutes: +dataFormatted?.shiftDuration?.minutes
                }
            } : []),
            ...(dataFormatted?.openingHours?.length > 0 ? {
                    openingHours: dataFormatted?.openingHours?.map((ele: any) => ({
                        start: {
                            hours: +ele.start.hours,
                            minutes: +ele.start.minutes,
                        },
                        end: {
                            hours: +ele.end.hours,
                            minutes: +ele.end.minutes,
                        }
                    }))
                }
                : []),
            ...(dataFormatted?.afternoonLimit ? {
                afternoonLimit: {
                    hours: +dataFormatted?.afternoonLimit?.hours,
                    minutes: +dataFormatted?.afternoonLimit?.minutes
                }
            } : []),
        }

        if (dataEdit && dataEdit?.idDocument) {
            http.put(`pharmacists/${pharmacist}/pharmacies/${dataToSend.idDocument}`, dataToSend).then(r => {
                dispatch(editPharmacy(r.pharmacy))
                closeFormHandler && closeFormHandler()
            })
        } else {
            http.post(`pharmacists/${pharmacist}/pharmacies`, dataToSend).then(r => {
                dispatch(addPharmacy(r.pharmacy))
                closeFormHandler && closeFormHandler()
            })
        }
    }
    const validations = [
        {
            name: 'name',
            validations: [
                {
                    name: required,
                    params: {name: "name"},
                },
            ],
        },
        {
            name: 'afternoonLimit___hours',
            validations: [
                {
                    name: required,
                    params: {name: "ore limite pomeridiano"},
                },
            ],
        },
        {
            name: 'afternoonLimit___minutes',
            validations: [
                {
                    name: required,
                    params: {name: "minuti limite pomeridiano"},
                },
            ],
        },
        {
            name: 'shiftDuration___hours',
            validations: [
                {
                    name: required,
                    params: {name: "ore durata turno"},
                },
            ],
        },
        {
            name: 'shiftDuration___minutes',
            validations: [
                {
                    name: required,
                    params: {name: "minuti durata turno"},
                },
            ],
        },
        ...(dataEdit?.idDocument ? [{
            name: 'timeBank',
            validations: [
                {
                    name: required,
                    params: {name: "gestione ore"},
                },
            ],
        }] : []),
        {
            openingHours: {
                form: [
                    {
                        name: 'start___hours',
                        validations: [
                            {
                                name: required,
                                params: {name: "ore inizio"},
                            },
                        ],
                    },
                    {
                        name: 'end___hours',
                        validations: [
                            {
                                name: required,
                                params: {name: "ore fine"},
                            },
                        ],
                    },
                    {
                        name: 'start___minutes',
                        validations: [
                            {
                                name: required,
                                params: {name: "minuti inizio"},
                            },
                        ],
                    },
                    {
                        name: 'end___minutes',
                        validations: [
                            {
                                name: required,
                                params: {name: "minuti fine"},
                            },
                        ],
                    }
                ]
            }

        },
        {
            openingHours: {
                form: [
                    {
                        name: 'start___hours',
                        validations: [
                            {
                                name: required,
                                params: {name: "ore inizio"},
                            },
                        ],
                    },
                    {
                        name: 'end___hours',
                        validations: [
                            {
                                name: required,
                                params: {name: "ore fine"},
                            },
                        ],
                    },
                    {
                        name: 'start___minutes',
                        validations: [
                            {
                                name: required,
                                params: {name: "minuti inizio"},
                            },
                        ],
                    },
                    {
                        name: 'end___minutes',
                        validations: [
                            {
                                name: required,
                                params: {name: "minuti fine"},
                            },
                        ],
                    }
                ]
            }
        }
    ]

    const hoursArray = Array.from({length: 24}, (_, i) => i);
    const minutesArray = Array.from({length: 4}, (_, i) => i * 15);

    const dataTimeHours: StructureFormModel = {
        type: formControlTypes.select,
        name: "name",
        options: hoursArray.map(ele => ({label: padNum(ele), value: ele})),
        dataElement: {
            placeholder: "Ore",
            type: 'text',
        },
        col: {xs: "12"},
    }

    const dataTimeMinutes: StructureFormModel = {
        type: formControlTypes.select,
        name: "name",
        options: minutesArray.map(ele => ({label: padNum(ele), value: ele})),
        dataElement: {
            placeholder: "Minuti",
            type: 'text',
        },
        col: {xs: "12"},
    }

    const structureDataCompanyName: StructureFormModel[] = [
        {
            type: formControlTypes.input,
            name: "name",
            label: "Nome",
            dataElement: {
                placeholder: "Inserisci nome azienda",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
    ]

    const structureDataShiftDurationH: StructureFormModel[] = [{...dataTimeHours, name: 'shiftDuration___hours'}]
    const structureDataShiftDurationM: StructureFormModel[] = [{...dataTimeMinutes, name: 'shiftDuration___minutes'}]

    const structureArrayOpeningHours = [
        {
            type: formControlTypes.select,
            name: "start___hours",
            label: "Inizio",
            options: hoursArray.map(ele => ({label: padNum(ele), value: +ele})),
            dataElement: {
                placeholder: "Ore",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},

            col: {xs: "12", lg: "6"},
        },
        {
            type: formControlTypes.select,
            name: "start___minutes",
            label: " ",
            options: minutesArray.map(ele => ({label: padNum(ele), value: ele})),
            dataElement: {
                placeholder: "Minuti",
                type: 'text',
            },
            display: {form: 'row', label: 'd-none', child: 'col-8'},

            col: {xs: "12", lg: "6"},
        },
        {
            type: formControlTypes.select,
            name: "end___hours",
            options: hoursArray.map(ele => ({label: padNum(ele), value: ele})),
            label: "Fine",
            dataElement: {
                placeholder: "Ore",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12", lg: "6"},
        },
        {
            type: formControlTypes.select,
            name: "end___minutes",
            label: " ",
            options: minutesArray.map(ele => ({label: padNum(ele), value: ele})),
            dataElement: {
                placeholder: "Minuti",
                type: 'text',
            },
            display: {form: 'row', label: 'd-none', child: 'col-8'},
            col: {xs: "12", lg: "6"},
        },

    ]

    const structureDataAfternoonLimitH: StructureFormModel[] = [{...dataTimeHours, name: 'afternoonLimit___hours'}]
    const structureDataAfternoonLimitM: StructureFormModel[] = [{...dataTimeMinutes, name: 'afternoonLimit___minutes'}]

    const structureDataCompanyOthers: StructureFormModel[] = [
        {
            type: formControlTypes.select,
            name: "timeBank",
            label: "Gestione ore",
            options: [{label: 'Banca Ore', value: true}, {label: 'Straordinario', value: false}],
            dataElement: {
                placeholder: "Seleziona Gestione ore",
                type: 'text',
                disabled: !!dataEdit?.idDocument,
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
        {
            type: formControlTypes.checkboxSingle,
            name: "default",
            label: "Azienda di default",
            dataElement: {
                placeholder: "Seleziona ",
                type: 'text',
            },
            display: {form: 'row', label: 'col-4', child: 'col-8'},
            col: {xs: "12"},
        },
    ]

    const {
        dataFormatted,
        dataForm,
        setData,
        errors,
        isSubmit,
        changeValue,
        submitAction
    } = useForm(submitActionHandler, validations, {
        shiftDuration___hours: '04',
        shiftDuration___minutes: '00',
        afternoonLimit___hours: '12',
        afternoonLimit___minutes: '00',
        timeBank: true,
        openingHours___0___start___hours: '08',
        openingHours___0___start___minutes: '00',
        openingHours___0___end___hours: '12',
        openingHours___0___end___minutes: '00',
    })

    const setDataHandler = (newDataFormatted: any[], name: string) => {
        setData({...dataFormatted, [name]: newDataFormatted})
    }
    return (
        <div>
            <div className={'form-container'}>
                <FormElements structure={structureDataCompanyName} changeValue={changeValue} dataForm={dataForm}
                              errors={errors} isSubmit={isSubmit}/>
                <div className={'row'}>
                    <div className="col-4">
                        <Label label={'Durata turno'}/>
                    </div>
                    <div className="col-8">
                        <div className="row">
                            <div className="col-6">
                                <FormElements structure={structureDataShiftDurationH} changeValue={changeValue}
                                              dataForm={dataForm}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                            <div className="col-6">
                                <FormElements structure={structureDataShiftDurationM} changeValue={changeValue}
                                              dataForm={dataForm}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                        </div>
                    </div>
                </div>


                <FormElementsArray
                    structure={structureArrayOpeningHours} pre={'openingHours'}
                    setData={setDataHandler}
                    dataFormatted={dataFormatted?.openingHours || []}
                    dataForm={dataForm}
                    errors={errors}
                    isSubmit={true}
                    changeValue={changeValue}
                    addLabel={'Aggiungi fascia'}
                    titleTemplate={<div className={"col-3 pt-2 me-5"}>{'Fascia'}</div>}/>


                <div className={'row mt-4'}>
                    <div className="col-4">
                        <Label label={'Limite pomeridiano'}/>
                    </div>
                    <div className="col-8">
                        <div className="row">
                            <div className="col-6">
                                <FormElements structure={structureDataAfternoonLimitH} changeValue={changeValue}
                                              dataForm={dataForm}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                            <div className="col-6">
                                <FormElements structure={structureDataAfternoonLimitM} changeValue={changeValue}
                                              dataForm={dataForm}
                                              errors={errors} isSubmit={isSubmit}/>
                            </div>
                        </div>
                    </div>
                </div>


                <FormElements structure={structureDataCompanyOthers} changeValue={changeValue}
                              dataForm={dataForm}
                              errors={errors} isSubmit={isSubmit}/>

            </div>

            <BtnRow submitAction={submitAction} closeFormHandler={closeFormHandler}/>

        </div>
    );
};

export default FormAddCompany;
